module.exports = __webpack_public_path__ + "static/media/Linearicons-Free.03e91f12.woff2";